import React, { useState, useEffect } from 'react';
import Link from "components/Link";
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import Notifications from "../Notifications";
import OrderTracking from 'components/Header/OrderTracking';
import RepeatLastOrder from "components/RepeatLastOrder";
import TagManagerService from 'services/TagManager/';
import OrdersService from 'services/Orders/';
import CartAction from 'actions/Cart';
import StorageService from 'services/StorageService';
import { userMenuTxt } from 'config/translate/variables';
import { HtmlParse, elipsis } from 'utils';
import logoPrime from 'images/icons/logo-jumbo-prime.svg';
import { paymentDebitWallet, frequentProductsID, primeFlag } from 'config';
import { ecommerce } from 'config/constants';
import FrequentProducts from '../FrequentProducts';
import useVariant from 'hooks/useVariant';
import style from './style.scss';//NOSONAR

let actions = [];

const UserMenu = (props) => {
    const [menuUser, setMenu] = useState(false);
    const [lastOrder, setLastOrder] = useState(false);
    const name = props.name ? props.name.split(' ')[0] : '';
    const dataUser = StorageService.getSecureItem('userData');
    const notPrime = !(dataUser.CencoPrime_2020 || dataUser.CencoPrime_CAT);

    const variant = useVariant(frequentProductsID);
    const newVariant = variant === '1';


    useEffect(() => {
        actions.push(PubSub.register('toggle_menu', closeUserMenu));
        getLastOrder();

        return function cleanup(){
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    },[]);

    const logOut = () => {
        CartAction.logout(()=> {CartAction.logoutRedirect()});
    };

    const closeUserMenu = (payload) => {
        const value = payload.value;
        setMenu(value ? value.state : false);
    };

    const clickFrequentProducts = (action, tag) => {
        clickTagManager(action, tag);
        TagManagerService.interaction('Variante 0', 'Productos Frecuentes', 'Menu Desktop');
    };

    const clickTagManager = (action, tag) => {
        TagManagerService.clickHeader(action, tag);
    };

    const clickMenuUser = () => {
        TagManagerService.clickHeader(`User Menu: Hola ${name}`, 'header');
        setMenu(!menuUser);
        PubSub.dispatch('toggle_minicart', {state: false});
        PubSub.dispatch('toggle_preheader', {state: false});
        PubSub.dispatch('close_tracking');
    };

    const getLastOrder = () => {
        OrdersService.getLastOrder().then(data => {
            setLastOrder(data);
        });
    };

    const _openPrimeRegister = () => {

        let pathName = window.location.pathname;
        TagManagerService.interaction('Quiero ser Prime', pathName, 'Header Top');  

        PubSub.dispatch('drawer_register_prime_open')
    }

    return <span className="new-header-user-menu-desktop" >
        {!ecommerce.whiteLabel && newVariant && <FrequentProducts />}
        {!ecommerce.whiteLabel && <Notifications />}
        {ecommerce.whiteLabel && <OrderTracking offers={props.offers}/>}
        <button className="new-header-main-name" onClick={() => clickMenuUser()}>
            <div className="new-header-title-wrap">
                <i className="jumbo-icon-new-user"></i>
                <span className='new-header-title'>Hola {elipsis(name, 12)}</span>
            </div>
            <div className="new-header-icon-wrap">
                <i className={"font-icn arrow-down" + (menuUser ? ' show' : '')} />
            </div>
        </button>
        <div className={'new-header-sup-links-menu-account' + (menuUser ? ' show' : '')} onMouseLeave={() => { setMenu(false) }}>
            <div className={'new-header-user-menu-arrow-up' + (menuUser ? ' show' : '')}></div>
            {notPrime && primeFlag && <div className="new-header-user-cenco-no-prime" onClick={_openPrimeRegister}>Quiero ser <i className="logo-prime">{HtmlParse(logoPrime)}</i></div>}
            <ul className='new-header-sup-links-menu-account-items'>
                <li><Link className="new-header-sup-links-text" to="/mis-datos" onClick={() => clickTagManager(userMenuTxt.info, '/mis-datos')}>{userMenuTxt.info}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/mis-compras" onClick={() => clickTagManager(userMenuTxt.orders, '/mis-compras')}>{userMenuTxt.orders}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/mis-listas-de-compras" onClick={() => clickTagManager(userMenuTxt.lists, '/mis-listas-de-compras')}>{userMenuTxt.lists}</Link></li>
                <li><Link className="new-header-sup-links-text" to="/mis-tarjetas" onClick={() => clickTagManager(userMenuTxt.cards, '/mis-tarjetas')}>{userMenuTxt.cards}</Link></li>
                {!newVariant && <li><Link className="new-header-sup-links-text" to="/productos-frecuentes" onClick={() => clickFrequentProducts(userMenuTxt.frequentProducts, '/productos-frecuentes')}>{userMenuTxt.frequentProducts}</Link></li>}
                <li className="sup-link-wrap">
                    <Link className="new-header-sup-links-text" to="/productos-favoritos" onClick={() => clickTagManager(userMenuTxt.favoriteProducts, '/productos-favoritos')}>{userMenuTxt.favoriteProducts}</Link> 
                </li>
                {paymentDebitWallet && <li><Link className="new-header-sup-links-text" to="/mi-cuenta-bancaria" onClick={() => clickTagManager(userMenuTxt.bank, '/mi-cuenta-bancaria')}>{userMenuTxt.bank}</Link></li>}

                {(!notPrime && primeFlag )&& <li><Link className={"new-header-sup-links-text " + (!notPrime ? ' prime ' : '')} to="/prime" onClick={() => clickTagManager(userMenuTxt.prime.userPrime, '/prime')}>{userMenuTxt.prime.userPrime} <i className="logo-prime">{HtmlParse(logoPrime)}</i></Link></li>}

                {lastOrder && <li className="last-order-menu"><RepeatLastOrder/></li>}
                <li onClick={logOut}><a className="new-link new-header-sup-links-text close-session" onClick={() => clickTagManager(userMenuTxt.logout, 'header')}>{userMenuTxt.logout}</a></li>
            </ul>
        </div>
    </span>;
};

UserMenu.propTypes = {
    name: PropTypes.string
}
export default UserMenu;
